import { CSSObject, FlexProps } from '@chakra-ui/react';

export const MultiCardWrapper: CSSObject = {
  boxShadow:
    '0px 0px 0px 1px rgba(55, 140, 255, 0.50) inset, 0px 4px 10px 0px rgba(0, 0, 0, 0.30)',
  bg: 'alpha.400',
  borderRadius: 'md',
  p: '2',
  color: 'white',
  my: '0',
  gap: '0',
};
export const EventTitle: CSSObject = {
  fontWeight: 'extrabold',
  fontSize: 'sm',
  textTransform: 'capitalize',
  color: 'white',
  fontFamily: 'accent',
};
export const HeaderContainer: CSSObject = {
  gap: '2',
  p: '2',
  pb: '0',
};
export const MultiIconSVG: CSSObject = {
  color: 'alpha.700',
};
export const MultiCardsContainer: CSSObject = {
  mx: '-2',
  gap: '0',
  py: '0',
};
export const FlexEventDetails: CSSObject = {
  gap: '2',
};
export const EmptyMultiIcon: CSSObject = {
  color: 'alpha.700',
};
export const UnableToCreateMultiWrapper: CSSObject = {
  p: '2.5',
  color: 'white',
  background: 'whiteAlpha.100',
  boxShadow:
    '0px 3px 8px 0px rgba(0, 0, 0, 0.15), 0px 0px 0px 1px rgba(255, 255, 255, 0.16) inset',
  fontSize: 'xs',
  fontWeight: 'medium',
  borderRadius: 'md',
  mb: '3',
  '.chakra-icon': {
    color: 'beta.500',
    filter: 'drop-shadow(0px 0px 9px rgba(255, 110, 32, 0.3))',
  },
};
export const flexEventProps: FlexProps = {
  sx: {
    "[class$='EventTitle']": {
      fontWeight: 'bold',
      fontSize: 'xs',
    },
  },
};
export const MultiCardInputContainer: CSSObject = {
  mb: '2',
};
